import React from 'react';
import { Avatar } from '@mui/material';
import { useDispatch } from 'react-redux';
import { SOFT_SILVER } from '../../config/color';
import { generateUrl } from '../../services/utils';
import { ROUTE } from '../../constant/routeConstants';
import { setSelectedTagData } from '../../store/tags/reducer';
import { encrypt } from '../../services/encryptDecryptService';
import { setSelectedAppData } from '../../store/application/reducer';

const TagList = ({ tagList }) => {
  const dispatch = useDispatch();

  const updatedTagList =
    Object.keys(tagList || {})
      ?.filter((key) => !key.endsWith('Count'))
      ?.map((key) => ({
        title: key,
        tagList: tagList[key],
      })) || [];

  const RenderTagList = ({ list }) => {
    return list?.map((ele, index) => (
      <div
        key={index}
        onClick={() => {
          window.open(
            generateUrl(
              ROUTE.APP_DETAILS,
              encrypt({
                data: ele?.ApplicationId,
              }),
            ),
            '_blank',
          );
          dispatch(setSelectedTagData(ele));
          dispatch(setSelectedAppData(null));
        }}
        className="my-3 cursor-pointer rounded-xl bg-white px-4 py-3 text-start shadow-3xl"
      >
        <p className="break-words text-body2 font-bold text-dark-grey-black">{ele?.TagNumber}</p>
        <p className="break-words text-body1 font-normal text-dark-charcoal">{ele?.TagSummary}</p>
        <div className="flex items-center justify-between gap-2 pt-1">
          <div className="flex items-center justify-between gap-2">
            <Avatar
              alt={ele?.User?.toUpperCase()}
              src="/static/images/avatar/1.jpg"
              sx={{
                width: 23,
                height: 23,
                py: '14px',
                px: '14px',
                color: 'black',
                fontSize: '16px',
                backgroundColor: SOFT_SILVER,
              }}
            />
            <p className="text-body1 font-medium capitalize text-dark-charcoal">{ele?.User}</p>
          </div>
          <p className="text-bodySm font-normal text-dark-charcoal">{ele?.TagCreatedAgo}</p>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex items-center gap-4">
      {updatedTagList?.map((tag, ind) => {
        if (tag?.tagList?.length === 0) return null;

        return (
          <div
            key={ind}
            className="h-[calc(100vh-101px)] w-[390px] min-w-[390px] max-w-[390px] overflow-y-auto rounded-xl bg-light-white"
          >
            <div className="sticky top-0 z-10 bg-light-white pb-2 pt-5">
              <p className="px-5 text-start text-body2 font-medium text-dark-charcoal">
                {tag?.title} ({tag?.tagList?.length})
              </p>
            </div>

            <div className="overflow-y-auto px-3.5">
              <RenderTagList list={tag?.tagList} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TagList;
